import { DisabledPrompt, useRoute, useStateManager } from "@bcm-dev/bcms-vite";
import CountriesCustomSelect from "components/custom-ui/CountriesCustomSelect";
import StatesCustomSelect from "components/custom-ui/StatesCustomSelect";
import UIRadioGroup, { UIRadio } from "components/custom-ui/UIRadioGroup";
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton, UITextInput } from "components/ui";
import React from "react";

/**
 * @function PhysicalAddressWidget
 * @return {React.Component}
 * @exported true
 * @description The main widget used in the ACTContactInfoForeignPage. 
 */
export default function PhysicalAddressWidget(props) {
  const navigate = useRoute();
  const { data, onFormChange } = useStateManager();
  const addressType = data.addressType.physicalAddressType;

  return (
    <WidgetContainer className="physical-address-widget">
      <WidgetView text="Physical Address">
        <p className="form-description-text">
          Below is your current physical address which you may update immediately.
          To update or add a separate mailing address or a PO Box, please complete a <DisabledPrompt><a className="secure-form-link link clickable">Secure Form</a></DisabledPrompt> through online banking.
          The mailing address or PO Box will be updated within two business days.
        </p>
        <FormContainer className="physical-address-form small-form-width">
          <FormRowView className="address-type-row-view" text="*Address Type">
            <UIRadioGroup direction="horizontal" value={addressType} onChange={onFormChange("physicalAddressType")}>
              <UIRadio className="domestic-ui-radio" label="Domestic" name="phone-number-address-type" value="domestic" />
              <UIRadio className="foreign-ui-radio" label="Foreign" name="phone-number-address-type" value="foreign" />
            </UIRadioGroup>
          </FormRowView>
          <FormRowView className="address-line-1-row-view" text="* Address Line 1">
            <UITextInput />
          </FormRowView>
          <FormRowView className="address-line-2-row-view" text="Address Line 2">
            <UITextInput />
          </FormRowView>

          <FormRowView className="city-row-view" text="* City">
            <UITextInput />
          </FormRowView>
          {
            addressType === "domestic" &&
            <>
              <FormRowView className="state-row-view" text="* State">
                <StatesCustomSelect />
              </FormRowView>
              <FormRowView className="zip-row-view" text="* Zip Code">
                <UITextInput />
              </FormRowView>
            </>
          }
          {
            addressType === "foreign" &&
            <>
              <FormRowView className="state-or-province-view" text="State or Province">
                <UITextInput />
              </FormRowView>
              <FormRowView className="postal-code-view" text="Postal Code">
                <UITextInput />
              </FormRowView>
              <FormRowView className="country-view" text="* Country">
                <CountriesCustomSelect />
              </FormRowView>
            </>
          }
          <FormButtonRow>
            <SecondaryButton text="Cancel" onClick={() => { navigate("/profile") }} />
            <DisabledPrompt>
              <PrimaryButton text="Update" />
            </DisabledPrompt>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>

  )
}
